var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{on:{"layout":function($event){_vm.layout = $event}}})],1),(_vm.enableSeasonFeature)?_c('snow-fall'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }